import { ChangeDetectionStrategy, Component, OnInit, computed, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { combineLatest, Observable, distinctUntilChanged, filter, map } from 'rxjs';

import { NotificationTheme } from '@fcom/ui-components/components/notifications/enums';
import { LanguageService } from '@fcom/ui-translate';
import { compareAsJson } from '@fcom/core/utils/utils';
import { FinnairThemeService } from '@fcom/common/services/theme/finnair-theme.service';
import { FinnairTheme } from '@fcom/common/interfaces/theme.interface';

import { CampaignBannerService } from '../../../services/campaign-banner/campaign-banner.service';
import { ElementTypes, GaContext } from '../../../interfaces/gtm.interface';

interface CampaignBanner {
  text: string;
  link: { url: string };
  test?: {
    text: string;
    link: { url: string };
  };
  enableBlackTeaser?: boolean;
}

@Component({
  selector: 'fin-campaign-banner',
  templateUrl: './campaign-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CampaignBannerComponent implements OnInit {
  private languageService = inject(LanguageService);
  private route = inject(ActivatedRoute);
  private campaignBannerService = inject(CampaignBannerService);
  private themeService = inject(FinnairThemeService);

  readonly ElementTypes = ElementTypes;
  readonly GaContext = GaContext;
  readonly NotificationTheme = NotificationTheme;

  readonly isNewBrand = computed<boolean>(() => this.themeService.siteTheme() !== FinnairTheme.LEGACY);

  visibility$: Observable<boolean>;
  campaignLink$: Observable<CampaignBanner>;

  ngOnInit(): void {
    this.visibility$ = this.campaignBannerService.visibility$.pipe(distinctUntilChanged());
    this.campaignLink$ = combineLatest([
      this.languageService.translate<CampaignBanner>('campaignBanner'),
      this.route.queryParams,
    ]).pipe(
      distinctUntilChanged(compareAsJson),
      filter(([translations]) => !!(translations?.link?.url && translations?.text)),
      filter(([, queryParams]) => !(queryParams.utm_campaign && queryParams.utm_source)),
      map(([translations]) => translations),
      distinctUntilChanged()
    );
  }
}
